import { useNavigate } from "react-router-dom";
import OrdiniFornitori from "../acquisti/OrdiniFornitori";

const OrdiniOperatore = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto p-4">
        <OrdiniFornitori area="food" onBack={() => navigate(-1)} showStorico />
      </div>
    </div>
  );
};

export default OrdiniOperatore;
